module.exports = __webpack_public_path__ + "img/carwashing.0e89947f.png";